import React from 'react';
import './Hero.css';
import HeroCarousel from '../../ui/Carousel'

const HeroSection = ({ navigate, carouselImages }) => {
  return (
    <section className="relative pt-3 md:h-[40vh] lg:h-[60vh] xl:h-[100vh] overflow-hidden skewed-bg bg-gray-50">
      <div className="absolute top-0 left-0 w-full h-full bg-[#2584C6] transform -skew-y-6 lg:-skew-y-12 origin-top-left z-0"></div>
      
      <div className="relative z-10 grid grid-cols-1 lg:grid-cols-2 justify-center items-center text-white px-6 md:px-16 py-8 gap-8 h-full">
        <div className="space-y-6 mt-10" data-aos="fade-right">
          <h1 className="text-3xl md:text-4xl xl:text-5xl font-bold leading-snug">
            Smart. Secure. Scalable. Your Digital Evolution Starts Here.
          </h1>
          <p className="text-md md:text-lg xl:text-xl leading-relaxed">
            We help organizations evolve faster with scalable software, smart automation, 
            and future-ready digital architecture.
          </p>
          <button
            onClick={() => navigate('/contact')}
            className="bg-[#F7941D] text-white px-6 py-2 rounded-md font-semibold hover:bg-orange-500 transition duration-300"
          >
            Contact Us
          </button>
        </div>

        <div className="w-full flex justify-center" data-aos="fade-left">
          <HeroCarousel carouselImages={carouselImages} />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
